import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Public SEO routes are prerendered to static HTML at build time (scripts/prerender-ssg.js).
// When that markup is present, preload the matched route chunk first so hydration
// reconciles instantly (no blank flash); otherwise mount fresh.
async function boot() {
  try {
    if (container && container.hasChildNodes()) {
      try {
        const { PUBLIC_TOOL_MODULES } = await import("@/pages/checkit/public/routes");
        const importer = PUBLIC_TOOL_MODULES[window.location.pathname];
        if (importer) await importer();
      } catch (_) { /* ignore preload errors */ }
      hydrateRoot(container, app);
    } else {
      createRoot(container).render(app);
    }
  } catch (_) {
    if (container) createRoot(container).render(app);
  }
}

boot();
